export { default } from './InsurancePartnerView'
export * from './InsurancePartnerView'
